import React, { Component } from 'react';
import LoaderOverlayContext from './context';

class LoaderOverlayProvider extends Component {
  state = {
    visible: false,
  };
  setVisible = visible => {
    this.setState({ visible });
  };

  render() {
    const { visible } = this.state;
    const { setVisible } = this;
    return (
      <LoaderOverlayContext.Provider
        value={{
          visible,
          setVisible,
        }}
      >
        {this.props.children}
      </LoaderOverlayContext.Provider>
    );
  }
}

export default LoaderOverlayProvider;
